import { useEffect, useState } from 'react';
import { Layout } from '../../../components/layout';
import { TabsButton } from '../../../components/TabsButton';
import { choosePlatform } from '../../../helpers/utils';
import { useNavigateStore } from '../../../store/navigation';
import { useUserStore } from '../../../store/user';
import { AllTournament } from './All';
import { MyTournament } from './MyTournament';
import { MyTournamentPicks } from './Picks/MyTournament';

export const Tournaments = () => {
	const user = useUserStore((state) => state.user);
	const navigateState = useNavigateStore((state: any) => state.navigateState);
	const cameFromBackButton = useNavigateStore(
		(state: any) => state.cameFromBackButton
	);
	const [filters, setFilters] = useState({
		open: 'Inscrições abertas',
		finish: '',
	});
	const initialPage = choosePlatform()
		? 'Meus Torneios'
		: navigateState?.tabsSelect || 'Todos';
	const [tabs, setTabs] = useState(initialPage);

	useEffect(() => {
		if (cameFromBackButton && navigateState) {
			setFilters(navigateState.filter);
			setTabs(navigateState.tabsSelect);
		}
	}, []);

	const handleFilter = (type: string, status: string) => {
		if (type === 'open') {
			setFilters((prev) => ({
				...prev,
				open: prev.open === status ? '' : status,
			}));
		}
		if (type === 'closed') {
			setFilters((prev) => ({
				...prev,
				finish: prev.finish === status ? '' : status,
			}));
		}
	};

	const tabsData = [
		{
			title: 'Todos',
			isLoggedRequired: false,
			renderPage: () => (
				<AllTournament
					filter={filters}
					onChangeFilter={handleFilter}
					tabsSelect={tabs}
				/>
			),
		},
		{
			title: 'Meus Torneios',
			isLoggedRequired: user ? false : true,
			renderPage: () => (
				<MyTournament
					filter={filters}
					onChangeFilter={handleFilter}
					tabsSelect={tabs}
				/>
			),
		},
	];

	const tabsDataPick = [
		{
			title: 'Meus Torneios',
			isLoggedRequired: user ? false : true,
			renderPage: () => (
				<MyTournamentPicks
					filter={filters}
					onChangeFilter={handleFilter}
					tabsSelect={tabs}
				/>
			),
		},
	];

	const tabsAdmin = [
		{
			title: 'Todos',
			isLoggedRequired: false,
			renderPage: () => (
				<AllTournament
					filter={filters}
					onChangeFilter={handleFilter}
					tabsSelect={tabs}
				/>
			),
		},
		{
			title: 'Meus Torneios',
			isLoggedRequired: user ? false : true,
			renderPage: () => (
				<MyTournament
					filter={filters}
					onChangeFilter={handleFilter}
					tabsSelect={tabs}
				/>
			),
		},
		{
			title: 'Meus Torneios Pick',
			isLoggedRequired: user ? false : true,
			renderPage: () => (
				<MyTournamentPicks
					filter={filters}
					onChangeFilter={handleFilter}
					tabsSelect={tabs}
				/>
			),
		},
	];

	const onChangeTabs = (tab: string) => {
		setTabs(tab);
	};

	return (
		<Layout>
			<div className="px-3 lg:max-w-screen-xl lg:mx-auto">
				<div className="flex items-center flex-row justify-between py-6 lg:max-w-screen-xl lg:mx-auto lg:pt-4">
					<div></div>
					<p className="text-xl font-semibold text-custom-gray1 font-bahnschrift">
						Torneios
					</p>
					<div></div>
				</div>

				<div className="flex flex-col gap-2">
					<TabsButton
						initialPage={initialPage}
						render={
							user?.permisson === 'admin'
								? tabsAdmin
								: choosePlatform()
								? tabsDataPick
								: tabsData
						}
						onChangeTab={onChangeTabs}
					/>
				</div>
			</div>
		</Layout>
	);
};
